import { withSignUpLoginWizard } from '../services/signUpLogin';
import { withPaymentData } from '../data/payment';
import { withLicenseWizard } from '../services/license';
import { withAccountSettingsWizard } from '../services/accountSettings';
import { withTakeHomePayWarningWizard } from '../services/takeHomePayWarning';
import { useNickelsApis } from '../api/useNickelsApis';
import {
  IServiceContainer,
  IServiceModule,
  Scopes,
  createServiceModule,
} from '@aesop-fables/containr';
import { Authentication, Configuration, Logging } from '@3nickels/data-modules';
import { useRedirectHandlers } from '../redirects';
import { getApiEnvFromDomain } from './Environment';
import { usePaymentServices } from '../services/payment';
import { ActiveAppStateLogPredicate, AppStateRegistry } from '../AppState';
import { useUserEventServiceModule } from '../services/userEvents';
import { DataCatalogModule } from '@guidedchoice/scrinium';

export const bootstrap = (overrides: IServiceModule[] = []): IServiceContainer => {
  // Configuration
  const options: Configuration.BootstrappingOptions = {
    api: { environment: getApiEnvFromDomain() },
    alerts: { interval: 60000, predicate: ActiveAppStateLogPredicate, disableRunner: true },
  };
  const modules: IServiceModule[] = [
    Authentication.useWebSessionAuth,
    useNickelsApis,
    useUserEventServiceModule,
    usePaymentServices,
    withLicenseWizard,
    withSignUpLoginWizard,
    withAccountSettingsWizard,
    withTakeHomePayWarningWizard,
    useRedirectHandlers,
    useWebOverrides,
    Logging.useLogging({
      bufferInterval: 5000,
      maxLogsPerRequest: 100,
      predicate: ActiveAppStateLogPredicate,
    }),
    ...overrides,
  ];

  const storageModules: DataCatalogModule[] = [withPaymentData];

  return Configuration.bootstrap(options, modules, storageModules);
};

const useWebOverrides = createServiceModule('web', (services) => {
  services.remove(Authentication.AuthenticationServices.IsAuthenticated);
  services.autoResolve(
    Authentication.AuthenticationServices.IsAuthenticated,
    Authentication.IsAuthenticatedSubject,
    Scopes.Singleton
  );

  services.importRegistry(AppStateRegistry);
});
